import React from 'react';
import navigate from '@utils/navigate';

export function NavBar(props) {
	const onClick = React.useCallback((href) => {
		return (e) => {
			e.preventDefault();
			navigate(href);
		};
	}, []);

	if (!props?.menu) return '';

	return (
		<nav className="navbar navbar-expand-lg bg-dark border-bottom border-body" data-bs-theme="dark">
			<div className="container-fluid">
				<a className="navbar-brand" href="#">EstAgil</a>

				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>

				<div className="navbar-collapse collapse" id="navbarSupportedContent">
					<ul className="navbar-nav me-auto mb-2 mb-lg-0">
						{
							Object.keys(props.menu).map(option => {
								const item = props.menu[option];
								return (
									<li key={option} className={`nav-item ${item.dropdown ? 'dropdown' : ''}`}>
										{!item.dropdown && <a className='nav-link' href={''} onClick={onClick(item.href)}>{option}</a>}

										{!!item.dropdown && <a className='nav-link dropdown-toggle' href={''} role="button" data-bs-toggle="dropdown">{option}</a>}

										{!!item.dropdown && (
											<ul className="dropdown-menu">
												{item.dropdown.map(subitem => (
													<a className='dropdown-item' key={subitem.href} href={''} onClick={onClick(subitem.href)}>{subitem.label}</a>
												))}
											</ul>
										)}
									</li>
								);
							})
						}
					</ul>
				</div>
			</div>
		</nav>
	);
}
